import { CountryIsoCode } from "v2/domain/common/enums/CountryISOCode";
import SubsidyCard from "v2/ui/components/SubsidySection/components/SubsidyCard";
import SubsidySectionHeader from "v2/ui/components/SubsidySection/components/SubsidySectionHeader";
import BenefitBagList from "v2/ui/components/SubsidySection/components/BenefitBagList";
import DeliveriesEmptyState from "v2/ui/components/SubsidySection/components/DeliveriesEmptyState";

const haveBagDeliveries = (benefitModel) =>
  benefitModel?.benefitBagConfig?.length > 0;

const haveBagDeliveriesOrSubsidy = (benefitModel) =>
  haveBagDeliveries(benefitModel) || benefitModel?.subsidy;

const config = (benefitModel, country) => ({
  [CountryIsoCode.SPAIN]: (
    <>
      <SubsidySectionHeader benefitModel={benefitModel} />
      {haveBagDeliveriesOrSubsidy(benefitModel) ? (
        <>
          <SubsidyCard benefitModel={benefitModel} />
          <BenefitBagList benefitModel={benefitModel} country={country} />
        </>
      ) : (
        <DeliveriesEmptyState />
      )}
    </>
  ),
  [CountryIsoCode.MEXICO]: (
    <>
      <SubsidySectionHeader benefitModel={benefitModel} />
      {haveBagDeliveries(benefitModel) ? (
        <BenefitBagList benefitModel={benefitModel} country={country} />
      ) : (
        <DeliveriesEmptyState />
      )}
    </>
  ),
  [CountryIsoCode.PORTUGAL]: (
    <>
      <SubsidySectionHeader benefitModel={benefitModel} />
      {haveBagDeliveriesOrSubsidy(benefitModel) ? (
        <>
          <SubsidyCard benefitModel={benefitModel} />
          <BenefitBagList benefitModel={benefitModel} country={country} />
        </>
      ) : (
        <DeliveriesEmptyState />
      )}
    </>
  ),
});

export default config;
